import React, { useEffect, useCallback, useState } from 'react';
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css';
import { Box } from '@mui/material';
import axios from 'axios';
import { API_URL, UPLOAD_OR_DOWNLOAD_URL } from 'links/API_LINKS';

const TextEditor = ({ setFieldValue, valueToUpdate, initialtext }) => {
  // Keep track of content state locally
  const [content, setContent] = useState(initialtext || '');
  console.log(content)
  
  // Initialize quill editor
  const { quill, quillRef, Quill } = useQuill({
    modules: {
      magicUrl: true,
      toolbar: [
        ['bold', 'italic'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ size: ['small', false, 'large', 'huge'] }],
        [{ color: [] }],
        ['image'],
      ],
    },
    formats: [
      'bold',
      'list',
      'link',
      'color',
      'italic',
      'size',
      'underline',
      'image',
    ],
  });
  
  // Register Magic URL plugin
  if (Quill && !quill) {
    const MagicUrl = require('quill-magic-url').default;
    Quill.register('modules/magicUrl', MagicUrl);
  }

  // Set initial form value - this happens immediately on mount
  useEffect(() => {
    // console.log(`[TextEditor] Initializing ${valueToUpdate} with:`, initialtext || '');
    setContent(initialtext || '');
    setFieldValue(valueToUpdate, initialtext || '');
  }, [initialtext, setFieldValue, valueToUpdate]);
  
  // Initialize editor when it's ready - happens after quill is initialized
  useEffect(() => {
    if (!quill) return;
    
    // Set editor content ONLY from initialtext prop during initialization
    const contentToSet = initialtext || '';
    // console.log(`[TextEditor] Setting ${valueToUpdate} editor content:`, contentToSet);
    
    quill.root.innerHTML = contentToSet;
    
    // Setup change handler
    const handleChange = () => {
      const editorContent = quill.root.innerHTML;
      // console.log(`[TextEditor] ${valueToUpdate} changed to:`, editorContent);
      
      // Update local state and form field
      setContent(editorContent);
      setFieldValue(valueToUpdate, editorContent);
    };
    
    // Listen for changes
    quill.on('text-change', handleChange);
    
    // Clean up
    return () => {
      quill.off('text-change', handleChange);
    };
  }, [quill, initialtext, valueToUpdate, setFieldValue]);

  // Image handling functions
  const insertToEditor = useCallback(
    (imageUrl) => {
      const finalUrl = `${UPLOAD_OR_DOWNLOAD_URL}/${imageUrl}`;
      if (quill) {
        const range = quill.getSelection();
        if (range) {
          quill.insertEmbed(range.index, 'image', finalUrl);
        }
      }
    },
    [quill]
  );

  const uploadFile = useCallback(
    async (files) => {
      const fileExtension = files.name
        .substring(files.name.lastIndexOf('.') + 1)
        .toLowerCase();
      const formData = new FormData();
      formData.append('file', files);
      formData.append('field', 'PROFILE_IMAGE');
      formData.append('fileExtension', fileExtension);
      const result = await axios.post(API_URL + '/aws-upload/single', formData);
      if (result.status === 200) {
        insertToEditor(result.data.publicUrl);
      }
    },
    [insertToEditor]
  );

  const selectLocalImage = useCallback(() => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = () => {
      if (input.files && quill) {
        const file = input.files[0];
        uploadFile(file);
      }
    };
  }, [quill, uploadFile]);

  useEffect(() => {
    if (quill) {
      quill.getModule('toolbar').addHandler('image', selectLocalImage);
    }
  }, [quill, selectLocalImage]);

  return (
    <Box sx={{ height: 150 }} mb={8}>
      <div 
        ref={quillRef} 
        style={{ border: "1px solid #ddd", minHeight: "100px" }} 
      />
    </Box>
  );
};

export default TextEditor;
